// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderTitleBackButton-moduleEntityProfileHeaderTitleBackButton__c_PKq";
export { _1 as "EntityProfileHeaderTitleBackButton" }
